import { useRef, useEffect } from "react";

/* সবুজ-পর্দার ভিডিও → canvas-এ সবুজ কেটে স্বচ্ছ (গেটের মতই — দোকান-প্রতিনিধির জন্য) */
export default function GreenScreenVideo({ src, muted, videoRef, onError, onEnded, className, testid = "shop-rep-video" }) {
  const vidRef = useRef(null);
  const cvRef = useRef(null);

  useEffect(() => {
    const v = vidRef.current;
    const cv = cvRef.current;
    if (!v || !cv) return;
    const ctx = cv.getContext("2d", { alpha: true });
    let raf, stop = false;
    const render = () => {
      if (stop) return;
      if (v.readyState >= 2 && v.videoWidth) {
        if (cv.width !== v.videoWidth || cv.height !== v.videoHeight) {
          cv.width = 480;
          cv.height = 720;
        }
        ctx.drawImage(v, 0, 0, cv.width, cv.height);
        const img = ctx.getImageData(0, 0, cv.width, cv.height);
        const d = img.data;
        for (let i = 0; i < d.length; i += 4) {
          const r = d[i], g = d[i + 1], b = d[i + 2];
          const greenness = g - Math.max(r, b);
          if (greenness > 60) d[i + 3] = 0;
          else if (greenness > 25) d[i + 3] = Math.max(0, 255 - (greenness - 25) * 6);
          if (g > r && g > b) {
            const avg = (r + b) >> 1;
            if (g > avg) d[i + 1] = avg + ((g - avg) * 0.4) | 0;
          }
        }
        ctx.putImageData(img, 0, 0);
      }
      raf = requestAnimationFrame(render);
    };
    raf = requestAnimationFrame(render);
    return () => {
      stop = true;
      cancelAnimationFrame(raf);
    };
  }, [src]);

  return (
    <>
      <video
        ref={(el) => {
          vidRef.current = el;
          if (videoRef) videoRef.current = el;
          if (el) el.muted = muted; // React-এর muted-কুইর্ক — সরাসরি প্রপার্টি
        }}
        src={src}
        autoPlay
        muted={muted}
        playsInline
        onEnded={onEnded}
        onError={onError}
        className="pointer-events-none absolute left-0 top-0 h-1 w-1 opacity-0"
      />
      <canvas ref={cvRef} width="480" height="720" className={className} data-testid={testid} />
    </>
  );
}
